var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"result-section"},[_c('div',{staticClass:"result-title"},[_vm._v(" Result ")]),(!_vm.isRunExtraction)?_c('div',{staticClass:"result-document"}):_c('div',{staticClass:"result-document"},[_vm._v(" ผลิต ")])])}
var staticRenderFns = []

export { render, staticRenderFns }